// import {
//   loginByUsername,
//   login,
//   logout,
//   getUserRoutes,
//   getUserInfo,
// } from '@/api/login';
import { login, getUserRoutes } from '@/api/user';
import { getToken, setToken, removeToken } from '@/utils/auth';
import store from '@/store';
import { Message } from 'element-ui';
import { Notification, MessageBox } from 'element-ui';

const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    user_routes: [],
    setting: {
      articlePlatform: [],
    },
  },

  mutations: {
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_CODE: (state, code) => {
      state.code = code;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction;
    },
    // SET_SETTING: (state, setting) => {
    //   state.setting = setting
    // },
    // SET_STATUS: (state, status) => {
    //   state.status = status
    // },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_USER_ROUTES(state, routes) {
      // console.log(routes);
      state.user_routes = routes;
    },
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password)
          .then((response) => {
            if (response.code !== 200) {
              Message.error('用户名或密码错误');
            }
            // console.log(response);
            let { credentials, token } = response.data;
            commit('SET_TOKEN', token);
            commit('SET_USER', credentials);
            setToken(token);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token)
          .then((response) => {
            // 由于mockjs 不支持自定义状态码只能这样hack
            //lkx 此处获取用户路由

            if (!response) {
              reject('Verification failed, please login again.');
            }
            const data = response;

            if (data.roles && data.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit('SET_ROLES', data.roles);
            } else {
              reject('getInfo: roles must be a non-null array!');
            }

            commit('SET_NAME', data.name);
            commit('SET_AVATAR', data.avatar);
            commit('SET_INTRODUCTION', data.introduction);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetUserRoutes({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserRoutes()
          .then((res) => {
            if (res.data) {
              commit('SET_USER_ROUTES', res.data);
              resolve(res.data);
            } else if (res.code == 404) {
              MessageBox.alert('未授权，请重新登录');
              commit('SET_TOKEN', '');
              removeToken();
              commit('SET_USER_ROUTES', []);
              vueObj.$router.push('/login');
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '');
        commit('SET_USER_ROUTES', []);
        removeToken();
        resolve();
        // .then(() => {
        //   commit('SET_TOKEN', '');
        //   commit('SET_ROLES', []);
        //   removeToken();
        //   resolve();
        // })
        // .catch(error => {
        //   reject(error);
        // });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve();
      });
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', role);
        setToken(role);
        getUserInfo(role).then((response) => {
          const data = response;
          commit('SET_ROLES', data.roles);
          commit('SET_NAME', data.name);
          commit('SET_AVATAR', data.avatar);
          commit('SET_INTRODUCTION', data.introduction);
          dispatch('GenerateRoutes', data); // 动态修改权限后 重绘侧边菜单
          resolve();
        });
      });
    },
  },
};

export default user;
